<app-topbar></app-topbar>

<main class="content">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
